import { Component } from 'react';
import PropTypes from 'prop-types';
import mint from '@tunein/mint';
import isServer from '../../utils/isServer';

export default function withAdScreenRequest(getScreenName) {
  return (BaseComponent) => {
    class WithScreenAdRequest extends Component {
      static propTypes = {
        match: PropTypes.object.isRequired,
      };

      constructor(props) {
        super(props);
        if (!isServer()) {
          mint.updateState('currentScreen', getScreenName(props));
        }
      }

      componentDidUpdate(prevProps) {
        if (prevProps.match.params !== this.props.match.params) {
          mint.updateState('currentScreen', getScreenName(this.props));
        }
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    }

    return WithScreenAdRequest;
  };
}
